<div>
  @if (alertInfo.show) {
    <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false" class="mb-3">
      <strong>{{ alertInfo.type === 'danger' ? 'Error!' : 'Success!' }}</strong>
      <div [innerHTML]="alertInfo.message"></div>
    </ngb-alert>
  }

  @if (!readonly) {
    <div class="mb-4">
      @if (!showUploadForm && !showEditForm) {
        <div class="d-flex justify-content-end mb-3">
          <button type="button" class="btn btn-primary" (click)="toggleUploadForm()">
            <i class="fa fa-plus"></i> Upload New Document
          </button>
        </div>
      }
      @if (showUploadForm) {
        <div class="card border p-3 mb-3">
          <h5 class="mb-3">Upload New Document</h5>
          <form [formGroup]="form">
            <div class="row mb-3">
              <div class="col-md-6">
                <input-field
                  [label]="'Object'"
                  [inputFormControl]="getObjectControl()"
                  [placeholder]="'Enter document description'"
                  [readonly]="readonly">
              </input-field>
            </div>
            <div class="col-md-6">
              <label class="fw-bold mb-1">File</label>
              <div class="custom-file-input">
                <div class="input-group">
                  <input type="text" class="form-control" [value]="fileName" readonly>
                  <label class="input-group-text btn btn-outline-secondary">
                    <span>Browse</span>
                    <input type="file" (change)="onFileSelected($event)" style="display: none">
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <button type="button" class="btn btn-secondary" (click)="toggleUploadForm()">
              Cancel
            </button>
            <button type="button" [disabled]="loading" class="btn btn-success" (click)="onSubmit()">
              @if (loading) {
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              }
              Upload Document
            </button>
          </div>
        </form>
      </div>
    }
    @if (showEditForm) {
      <div class="card border p-3 mb-3">
        <h5 class="mb-3">Edit Document</h5>
        <form [formGroup]="editForm">
          <div class="row mb-3">
            <div class="col-md-12">
              <input-field
                [label]="'Title'"
                [inputFormControl]="getEditTitleControl()"
                [placeholder]="'Enter document title'"
                [readonly]="readonly">
            </input-field>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button type="button" class="btn btn-secondary" (click)="cancelEdit()">
            Cancel
          </button>
          <button type="button" [disabled]="loading" class="btn btn-primary" (click)="saveEdit()">
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            }
            Save Changes
          </button>
        </div>
      </form>
    </div>
  }
</div>
}

<h5 class="mb-3">Documents List</h5>

@if (loading) {
  <loader [config]="{ overlay: false, text: 'Loading documents...' }"></loader>
}

@if (!loading) {
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Date</th>
          <th>Who Uploaded</th>
          <th>Title</th>
          @if (!readonly) {
            <th>Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (document of documents; track document) {
          <tr>
            <td>{{ document.createTime | date:'MM/dd/yyyy' }}</td>
            <td>{{ document.creator.firstName }} {{document.creator.lastName}}</td>
            <td>{{ document.title }}</td>
            @if (!readonly) {
              <td>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="downloadDocument(document.attachments)">
                    <i class="fa fa-download"></i> Download
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-success" (click)="editDocument(document)">
                    <i class="fa fa-edit"></i> Edit
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteDocument(document)">
                    <i class="fa fa-trash"></i> Delete
                  </button>
                </div>
              </td>
            }
          </tr>
        }
        @if (documents.length == 0) {
          <tr>
            <td colspan="4" class="text-center">No documents found</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
</div>
